import { Form, FormProps, Input, InputNumber, Switch, Button } from 'antd'
import { BaseKey, file2Base64, useCan } from '@refinedev/core'
import { SingleImageUpload } from 'components/input'

export const ServiceForm: React.FC<{
  formProps: FormProps
  id?: BaseKey
  queryResult?: any
}> = ({ formProps, id, queryResult }) => {
  const { data: canUpdate } = useCan({
    resource: 'services',
    action: 'edit',
  })

  const { data: canCreate } = useCan({
    resource: 'services',
    action: 'create',
  })

  const isEdit = !!id
  const hasPermission = isEdit ? canUpdate?.can : canCreate?.can

  const onFinish = async (values: any) => {
    let serviceImage = ''
    const { image } = values

    delete values.image
    if (image) {
      const file = image[image?.length - 1]
      if (file.originFileObj) {
        serviceImage = await file2Base64(file)
      }
    }

    const finalResponse = { ...values }
    if (serviceImage.length) finalResponse['image'] = serviceImage

    return formProps.onFinish && formProps.onFinish(finalResponse)
  }

  return (
    <Form
      {...formProps}
      disabled={!hasPermission}
      layout="vertical"
      onFinish={onFinish}>
      <Form.Item name="name" label="Name">
        <Input />
      </Form.Item>
      <Form.Item name="service_email" label="Email">
        <Input />
      </Form.Item>
      <Form.Item name="order" label="Order">
        <InputNumber defaultValue={999} />
      </Form.Item>
      <Form.Item
        name="is_auto_required"
        label="Auto Required"
        valuePropName="checked">
        <Switch />
      </Form.Item>
      <SingleImageUpload
        label="Image"
        name="image"
        buttonText="Service Image"
        initialImageUrl={queryResult?.data?.data?.image}
        disabled={!hasPermission}
      />
      {hasPermission && (
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {isEdit ? 'Update Service' : 'Create Service'}
          </Button>
        </Form.Item>
      )}
    </Form>
  )
}
